import React from 'react';
import SystemFlag from '@/components/SystemFlag';
import HoverActionHeader from '@/components/HoverActionHeader';
import CatalogueTitleInput from './CatalogueTitleInput';
import Selectors from '../hooks/selectors';
import Events from '../../hooks/events';

const CatalogueTitle = ({
  category,
  code,
  errorCoordinate = 't-30',
  isNew,
}) => {
  const state = Selectors.useCatalogueTitle({ category, code });
  const showEdit = Events.useEditDataset(category, { code });

  return (
    <>
      {!state.isEditing && (
        <HoverActionHeader
          canEdit={state.canEdit}
          className="aridhia-catalogue-list-header"
          disabled={state.disabled}
          icon="table"
          isSystem={state.dataModel}
          renderSystemFlag={() => <SystemFlag messageText={state.dataModel} />}
          showEdit={() => showEdit(state)}
          value={state.name}
        />
      )}
      {state.canEdit && state.isEditing && (
        <CatalogueTitleInput
          autoFocus={isNew}
          category={category}
          className="aridhia-catalogue-title"
          code={code}
          errorCoordinate={errorCoordinate}
          icon="table"
          size="huge"
          withValidation
        />
      )}
    </>
  );
};

export default CatalogueTitle;
